module.exports = "../static/images/91ea81.gif";